import { useLocation, Navigate, Outlet } from "react-router-dom";
import React from "react";
import { getUsers } from "../utils/getUser";

const RequireAuth = ({ allowedRoles }) => {
  // const { auth } = useAuth();
  const location = useLocation();

  const user = getUsers();
  const token = user?.access_token;
  const userRole = user?.role?.toLowerCase();
  const requires2faAction = user?.requires_2fa_action;

  // Check if 2FA setup is pending
  if (requires2faAction === "setup") {
    // User has temp token but needs to complete 2FA setup
    return <Navigate to="/setup-2fa" state={{ userData: user }} replace />;
  }

  // Check if 2FA verification is pending during login
  if (requires2faAction === "verify") {
    // User needs to enter OTP, redirect to login
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Members without a linked Discord can only use the dashboard
  if (
    userRole === "member" &&
    !user?.is_discord_verified &&
    location.pathname !== "/user-dashboard"
  ) {
    return <Navigate to="/user-dashboard" replace />;
  }

  const verificationStatus = token ? true : false;

  return verificationStatus &&
    allowedRoles.find((role) => role === userRole) ? (
    <Outlet />
  ) : user ? (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};

export default RequireAuth;
